import CsvEtiquetasCrud from './CsvEtiquetasCrud'
export { CsvEtiquetasCrud }
export default CsvEtiquetasCrud
